<template>
	<span>{{ label }}</span>
	<Select class="params-select" v-model:value="addDays" :options="addDaysOptions" :disabled="disabled" />
</template>

<script>
import { computed, toRef } from 'vue';
import { Select } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import { useModelProxy } from '@/utils/useModelProxy';

export default {
	components: {
		Select,
	},
	emits: ['update:modelValue'],
	props: {
		modelValue: Number,
		action: String,
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const { t } = useI18n();
		const DAYS_PER_MONTH = 30;
		const addDays = useModelProxy(props, emit);
		if (addDays.value == null) {
			addDays.value = DAYS_PER_MONTH;
		}
		const addDaysOptions = computed(() => {
			const result = [];
			for (let i = 1; i <= 6; i++) {
				const days = i * DAYS_PER_MONTH;
				result.push({ value: days, label: t('tariffs.addDaysUnit', days) });
			}
			return result;
		});
		const actionRef = toRef(props, 'action');
		const label = computed(() => t('tariffs.addDaysLabel.' + actionRef.value));
		return {
			addDays,
			addDaysOptions,
			label,
		};
	},
}
</script>

<style scoped>
.params-select {
	max-width: 300px;
}
</style>